import { defineComponent as _defineComponent } from 'vue'
import { calculateDepth } from '../../utils/helpers';
import { computed, ref, watchEffect } from "vue";
import nestedDraggable from "./DraggableRow.vue";
import { TableItem } from './types';
import { MoveEvent } from 'vuedraggable';
import CheckBox from '../../components/selection-controls/CheckBox.vue'

type TableHeader = {
  text: string;
  justify: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SortableTreeTable',
  props: {
    headers: null,
    value: null,
    disableDrag: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
    selectedRows: { default: () => [] }
  },
  emits: ["input", "row-select"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: TableItem[]): void;
  (e: 'row-select', item: number | (string | number)[] | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { headers: TableHeader[], value: TableItem[], disableDrag: boolean, selectable: boolean, selectedRows: (string| number)[] };



const list = computed<TableItem[]>(() => props.value);
const dropzoneItem = ref<string>('');
const isDragAreaExpanded = ref(false);
const containsActions = computed(() => props.headers.some(head => head.text.length === 0));



// since the row component is recursive (it renders itself),
// we have put these event in this component
function onStart() {
  isDragAreaExpanded.value = true;
}

function onChange() {
  if(dropzoneItem.value) {
    dropzoneItem.value = '';
  }
  isDragAreaExpanded.value = false;
  list.value.forEach(calculateDepth(0));
  emit('input', list.value);
}

function selectAll(value: boolean) {
  emit('row-select', value ? list.value.map(item => item.id) : []);
}

function onMove(event: MoveEvent<TableItem>) {
  const index = (event.to.previousElementSibling as HTMLDivElement).dataset.index;
  dropzoneItem.value = index ? (index as string) : '';
}

watchEffect(
  () => {
    list.value.forEach(calculateDepth(0));
    emit('input', list.value);
  }
)


return { __sfc: true,props, list, dropzoneItem, isDragAreaExpanded, containsActions, emit, onStart, onChange, selectAll, onMove, nestedDraggable, CheckBox }
}

})